
/**
 * 根据 code（权限字段） 查找菜单对象
 */
export function findByCode(menuData, code) {
  if (!code || !menuData.length) return null;
  let result = null;

  function traverse(items) {
    for (const item of items) {
      if (item.code === code) {
        result = item;
        return;
      }
      if (item.children) {
        traverse(item.children);
        if (result) return;
      }
    }
  }
  traverse(menuData);
  return result;
}

/**
 * 根据选中的一级菜单，返回一级菜单下的末级菜单目录
 * id是子菜单id，parentId是父菜单id
 */
export function findLastLevelByFirstMenu(allMenuData, firstMenuId) {
  if (!firstMenuId || !allMenuData.length) return [];

  const firstMenu = allMenuData.find(item => item.id === firstMenuId);
  if (!firstMenu || !firstMenu.children || !firstMenu.children.length) return [];

  const results = [];

  function traverse(items, parentName) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      // 过滤掉按钮节点（btn: 开头）
      if (item.code && item.code.startsWith('btn:')) {
        continue;
      }
      // 判断是否有有效的菜单子节点
      const hasValidChildren = item.children && item.children.some(child => {
        return child.code && child.code.startsWith('menu:');
      });

      const isLeaf = !item.children || item.children.length === 0 || !hasValidChildren;
      if (isLeaf && item.code && item.code.startsWith('menu:')) {
        const displayName = parentName ? `${parentName} / ${item.name}` : item.name;
        results.push({
          id: item.id,
          name: displayName,
          code: item.code,
          parentId: item.parentId
        });
      } else {
        traverse(item.children, item.name);
      }
    }
  }
  traverse(firstMenu.children);
  return results;
}
